import { AxiosResponse } from 'axios';
import cacheableRequest from '../../../services/cacheableRequest';
import { LicenseResponse } from '../models/LicenseResponse';

export const getLicenses = (
  channel: 'TMG' | 'CLC',
  paired: boolean
): Promise<AxiosResponse<{ licenses: LicenseResponse[] }>> =>
  cacheableRequest(`/v1/licenses?unpaired=${!paired}&itemChannel=${channel}`, 5 / 60, false);
